/**
 * HEMS SSH Tüneller erişim kontrolü — GEÇİCİ.
 *
 * Roller henüz backend'de tanımlı değil. O zamana kadar HEMS SSH tunnel sayfası
 * sadece **süper admin** hesabına açık → e-posta allowlist. CNI tarafındaki
 * (cni-ssh-devices/access.ts) ile AYNI format ve aynı allowlist. Backend de aynı
 * kontrolü yapar (hems-ssh-api `SUPERADMIN_EMAILS`).
 *
 * İleride backend gerçek roller verince burası role-bazlı kontrole çevrilecek.
 */
// stg gerçek süper admin e-postası: "admin@oklidis.com.tr".
const SSH_SUPERADMIN_EMAILS = ["admin@oklidis.com.tr"] as const

// Lokal geliştirme istisnası: mock login e-postası "admin@oklidis.com" (.tr YOK).
// import.meta.env.DEV SADECE `npm run dev`'de true; her `vite build` (deploy
// image dahil) false → canlıda yine `.tr` şartı geçerli.
const SSH_DEV_PREVIEW_EMAILS = ["admin@oklidis.com"] as const

export function canAccessHemsSshDevices(email: string | null | undefined): boolean {
  if (!email) {
    return false
  }
  const normalized = email.trim().toLowerCase()
  if (SSH_SUPERADMIN_EMAILS.includes(normalized as never)) {
    return true
  }
  if (import.meta.env.DEV && SSH_DEV_PREVIEW_EMAILS.includes(normalized as never)) {
    return true
  }
  return false
}
